import { render, staticRenderFns } from "./CardProductHistory.vue?vue&type=template&id=20710610&scoped=true&"
import script from "./CardProductHistory.vue?vue&type=script&lang=js&"
export * from "./CardProductHistory.vue?vue&type=script&lang=js&"
import style0 from "./CardProductHistory.vue?vue&type=style&index=0&id=20710610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20710610",
  null
  
)

export default component.exports